function onInitForm() {
	$(
	  '.customBehaviour .gform_fields .gfield_visibility_visible label.gfield_label'
	).each(function () {
	  $(this).next().append($(this));
	});

	$(
	  '.customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_text, .customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_phone, .customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_email'
	).each(function () {
	  $(this).append('<span class="focus-border"></span>');
	});

	$(
	  '.customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_text input, .customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_phone input, .customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_email input'
	).each(function () {
	  $(this).focusout(function () {
		if ($(this).val() != '') {
		  $(this).addClass('has-content');
		} else {
		  $(this).removeClass('has-content');
		  $(this).val('');
		  // $('.popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input').val('');
		}
	  });
	});

	$(
	  '.customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_text input, .customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_phone input, .customBehaviour .gform_fields .gfield_visibility_visible .ginput_container_email input'
	).each(function () {
	  if ($(this).val() != '') {
		$(this).addClass('has-content');
	  } else {
		$(this).removeClass('has-content');
		$(this).val('');
	  }
	});
  }

export default {
	init() {
		onInitForm()

		$(document).on('gform_post_render', function(event, formId){
			if ($('.gform_validation_error').length > 0) {
				onInitForm()
			}
		});
	}
}